class WMSBroadcastMassiveDispatchUtil {
    constructor() {
      this.LOCK_KEY = "wms-massive-upload-locked";
      this.CHANNEL_NAME = "wms-upload-channel";
      this.MESSAGES = {
        LOCK: "LOCK",
        UNLOCK: "UNLOCK"
      };
      
      this.channel = new BroadcastChannel(this.CHANNEL_NAME);
      this.listeners = new Set();
      this.isLocked = this.getStoredLockStatus();
      
      this.setupListeners();
    }
  
    getStoredLockStatus() {
      return localStorage.getItem(this.LOCK_KEY) === "true";
    }
  
    setupListeners() {
      this.storageHandler = this.handleStorageChange.bind(this);
      this.broadcastHandler = this.handleBroadcastMessage.bind(this);
  
      window.addEventListener("storage", this.storageHandler);
      this.channel.onmessage = this.broadcastHandler;
    }
  
    handleStorageChange(event) {
      if (event.key === this.LOCK_KEY) {
        this.isLocked = event.newValue === "true";
        this.notifyListeners();
      }
    }
  
    handleBroadcastMessage(event) {
      const { data } = event;
      
      if (data === this.MESSAGES.LOCK) {
        this.handleLock();
      } else if (data === this.MESSAGES.UNLOCK) {
        this.handleUnlock();
      }
    }
  
    handleLock() {
      this.isLocked = true;
      this.notifyListeners();
    }
  
    handleUnlock() {
      this.isLocked = false;
      this.notifyListeners();
    }
  
    subscribe(callback) {
      this.listeners.add(callback);
      return () => this.unsubscribe(callback);
    }
  
    unsubscribe(callback) {
      this.listeners.delete(callback);
    }
  
    notifyListeners() {
      this.listeners.forEach(callback => callback(this.isLocked));
    }
  
    lock() {
      localStorage.setItem(this.LOCK_KEY, "true");
      this.channel.postMessage(this.MESSAGES.LOCK);
      this.handleLock();
    }
  
    unlock() {
      localStorage.setItem(this.LOCK_KEY, "false");
      this.channel.postMessage(this.MESSAGES.UNLOCK);
      this.handleUnlock();
    }
  
    getIsLocked() {
      return this.isLocked;
    }
  
    destroy() {
      window.removeEventListener("storage", this.storageHandler);
      this.channel.close();
      this.listeners.clear();
    }
  }
  
  // Instancia Singleton
  let globalInstance = null;
  
  export const getWMSBroadcastUtil = () => {
    if (!globalInstance) {
      globalInstance = new WMSBroadcastMassiveDispatchUtil();
    }
    return globalInstance;
  };
  
  export default WMSBroadcastMassiveDispatchUtil;